export default "__VITE_ASSET__2198bb3d__"